import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import Styled from 'styled';
import { LinearProgress } from '@rmwc/linear-progress';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import IconButtonView from 'four-nets/ui/icon-button/icon-button-view';
import refresh from 'four-nets/icons/svg/icon_refresh.svg';
import clear from 'four-nets/icons/svg/icon_delete_2.svg';

import '@rmwc/linear-progress/styles';
import defaultStyles from './file-upload-list-item-view.scss';

@Styled(defaultStyles)
@observer
class FileUploadListItemView extends React.Component {
    render() {
        const { thumbnail, name, progress, uploading, error, onRemove, onRetry, styles } = this.props;

        const classNames = [styles.fileUploadList];

        if (thumbnail) {
            classNames.push(styles.hasThumbnail);
        }

        return (
            <div className={styles.fileUploadList}>
                <div className={styles.thumbnail}>
                    {thumbnail}
                    <p className={styles.name}>{name}</p>
                </div>
                <div className={styles.upload}>
                    {uploading ? <LinearProgress progress={(progress - 10) / 100} determinate={true} /> : null}
                    {error ? (
                        <div className={styles.error}>
                            <p className={styles.errorText}>
                                <FormattedMessage id='LABEL_UPLOAD_FAILED' />
                            </p>
                            <IconButtonView onClick={onRetry}>
                                <SVGIcon style={{ image: styles.icon }} src={refresh} />
                            </IconButtonView>
                        </div>
                    ) : null}
                    <button className={styles.removeButton} onClick={onRemove}>
                        <SVGIcon style={{ image: styles.icon }} src={clear} />
                    </button>
                </div>
            </div>
        );
    }
}

export default FileUploadListItemView;
